import { LtlPipelineViewModel } from "../../../../../../ViewModel/LtlPipelineViewModel";

export function isFirstLtlRoute(ltlPipeline: LtlPipelineViewModel) {
  return (ltlPipeline.routing?.length || 0) === 0;
}
